window.cafe = window.cafe || {};
cafe.fancafe = cafe.fancafe || {};
cafe.fancafe.ranking = cafe.fancafe.ranking || {};

cafe.fancafe.ranking.apiCaller = {
	getFandomRankingByHourly: function (category) {
		return $.ajax('/fancafe/ranking/fandom/hourly?categoryName=' + category);
	},
	getFandomRankingByDaily: function (category) {
		return $.ajax('/fancafe/ranking/fandom/daily?categoryName=' + category);
	},
	getFandomRankingByAnnually: function (category) {
		return $.ajax('/fancafe/ranking/fandom/annually?categoryName=' + category);
	},
	getCafeRankingByHourly: function () {
		return $.ajax('/fancafe/ranking/cafe/hourly');
	},
	getCafeRankingByDaily: function () {
		return $.ajax('/fancafe/ranking/cafe/daily');
	},
	getCafeRankingByAnnually: function () {
		return $.ajax('/fancafe/ranking/cafe/annually');
	},
	getCheerRankingByHourly: function () {
		return $.ajax('/fancafe/ranking/cheer/hourly');
	},
	getCheerRankingByDaily: function () {
		return $.ajax('/fancafe/ranking/cheer/daily');
	},
	getCheerRankingByWeekly: function () {
		return $.ajax('/fancafe/ranking/cheer/weekly');
	},
	getCheerRankingByAnnually: function () {
		return $.ajax('/fancafe/ranking/cheer/annually');
	}
};

cafe.fancafe.ranking.content = function (wrapElement, config){
	new Vue({
		el: wrapElement,
		data: function () {
			return {
				tabList: [
					{name: '팬덤랭킹', value: 'fandom'},
					{name: '카페랭킹', value: 'cafe'},
					{name: '응원랭킹', value: 'cheer'},
				],
				tabSelected: 'fandom',
				currentPage: config.currentPage
			};
		},
		methods: {
			sectionNameBy: function (tabSelected) {
				return tabSelected + '-ranking-section';
			},
			onTabSelected: function (tabSelected) {
				if (this.tabSelected === tabSelected) {
					return;
				}

				this.tabSelected = tabSelected;

				var locationPath = window.location.origin + '/_fancafe/' + tabSelected;

				if (this.isInCafeApp()) {
					locationPath += '?cafeapp=true';
				}

				if (cafe.util.canUseHistory()) {
					var state = history.state || {};
					state.currentPage = 1;
					this.currentPage = 1;
					history.replaceState(state, document.title, window.location.href);
					history.pushState(state, document.title, locationPath);
				}
			},
			landingGrpcode: function () {
				return Utils.getParamValue('grpcode') || '';
			},
			stateCurrentPage: function () {
				return this.currentPage;
			},
			isInCafeApp: function () {
				return !!Utils.getParamValue('cafeapp');
			}
		},
		created: function () {
			this.tabSelected = window.location.pathname.slice('/_fancafe/'.length) || 'fandom';
			if (cafe.util.canUseHistory()) {
				history.replaceState(history.state || {}, document.title, window.location.href);

				var vueObject = this;
				window.addEventListener('popstate', function (e) {
					vueObject.tabSelected = window.location.pathname.slice('/_fancafe/'.length) || 'fandom';
					if (e.state && e.state.currentPage) {
						vueObject.currentPage = e.state.currentPage;
					}
				});
			}
		}
	});
};

cafe.fancafe.ranking.component = {
	sectionTabList: Vue.component('section-tab-list', {
		props: ['currentTab', 'tabList'],
		template: '' +
			'<ul id="fanCafeSortOption" role="tablist" class="rank_tab_wrap">' +
			'<li v-for="tab in tabList" :aria-selected="ariaSelected(tab)" class="fancafe-tab">' +
			'	<a v-if="tab.value === \'fandom\'" role="tab" href="/_fancafe/fandom" class="fancafe-tab-button fancafe-tab-button--fandom" @click.prevent="onClick(tab.value)">{{tab.name}}</a>' +
			'	<a v-else role="tab" :href="/_fancafe/ + tab.value" class="fancafe-tab-button" @click.prevent="onClick(tab.value)">{{tab.name}}</a>' +
			'</li>' +
			'</ul>',
		methods: {
			ariaSelected: function (tab) {
				return (this.currentTab === tab.value) ? 'true' : 'false';
			},
			onClick: function (value) {
				this.$emit('tab-selected', value);
			}
		}
	}),
	fandomRankingSection: Vue.component('fandom-ranking-section', {
		props: ['landingGrpcode', 'currentPage', 'isInCafeApp'],
		template: '' +
			'<section class="rank_wrap" id="fandom">' +
			'	<h1 class="sr_only">팬덤랭킹</h1>' +
			'	<div class="sort_wrap">' +
			'		<sort-category-select :categories="categories" :section-name="sectionName" :selected="categorySelected" v-on:sort-category-selected="onSortCategorySelected"></sort-category-select>' +
			'		<sort-time-select :options="sort" :selected="sortSelected" :ranking-time="rankingTime" :section-name="sectionName" v-on:sort-time-selected="onSortTimeSelected"></sort-time-select>' +
			'	</div>' +
			'	<div class="rank_list_wrap">' +
			'		<ranking-list :ranking-list="rankingList.slice(0, 10)" key-name="grpid" :section-name="sectionName" :options="categorySelected" :is-top-ranking="true" :is-in-cafe-app="isInCafeApp"></ranking-list>' +
			'		<ranking-list v-if="rankingList.length > 10" :ranking-list="rankingList.slice(10, visibleItemCount)" key-name="grpid" :options="categorySelected" :section-name="sectionName" :is-top-ranking="false" :is-in-cafe-app="isInCafeApp"></ranking-list>' +
			'	</div>' +
			'	<ranking-more v-if="hasNext" v-on:more="getNext"></ranking-more>' +
			'</section>',
		data: function () {
			return {
				sectionName: 'fandom',
				pagingCount: 30,
				categories: [
					{value: '', name: '전체분야'},
					{value: 'musician', name: '가수'},
					{value: 'actor', name: '배우'},
					{value: 'sportsman', name: '스포츠'},
					{value: 'entertainer', name: '방송인'},
					{value: 'etc', name: '기타'}
				],
				categorySelected: '',
				sort: [
					{value: 'hourly', name: '실시간', format: 'HH:mm'},
					{value: 'daily', name: '일간', format: 'M월 D일'},
					{value: 'annually', name: '연간', format: 'YYYY년'}
				],
				sortSelected: 'hourly',
				rankingList: [{},{},{},{},{}],
				needLanding: false
			};
		},
		computed: {
			hasNext: function () {
				return this.visibleItemCount < this.rankingList.length;
			},
			visibleItemCount: function () {
				return this.pagingCount * this.currentPage;
			},
			rankingTime: function () {
				switch (this.sortSelected) {
				case 'hourly':
					return moment().startOf('hour').valueOf();
				case 'daily':
					return moment().startOf('day').subtract(1, 'days').valueOf();
				case 'annually':
					return moment().startOf('year').valueOf();
				default:
					return moment();
				}
			}
		},
		methods: {
			resetPaging: function () {
				this.currentPage = 1;
			},
			onSortCategorySelected: function (categorySelected) {
				if (this.categorySelected === categorySelected) {
					return;
				}

				this.categorySelected = categorySelected;
				this.resetPaging();
				this.getRankingList();
			},
			onSortTimeSelected: function (sortSelected) {
				if (this.sortSelected === sortSelected) {
					return;
				}

				this.sortSelected = sortSelected;
				this.resetPaging();
				this.getRankingList();
			},
			getRankingList: function () {
				var vueObject = this;
				switch (this.sortSelected) {
				case 'hourly':
					cafe.fancafe.ranking.apiCaller.getFandomRankingByHourly(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.fandomRankViewList;
					});
					break;
				case 'daily':
					cafe.fancafe.ranking.apiCaller.getFandomRankingByDaily(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.fandomRankViewList;
					});
					break;
				case 'annually':
					cafe.fancafe.ranking.apiCaller.getFandomRankingByAnnually(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.fandomRankViewList;
					});
					break;
				default:
					cafe.fancafe.ranking.apiCaller.getFandomRankingByHourly(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.fandomRankViewList;
					});
					break;
				}
			},
			getNext: function () {
				this.currentPage++;
			},
			clearLanding: function () {
				this.landingGrpcode = '';
				this.needLanding = false;
			},
			saveCurrentState: function () {
				if (!!(cafe.util.canUseHistory() && history.state)) {
					var state = history.state || {};
					state.scrollTop = window.scrollY;
					state.categorySelected = this.categorySelected;
					state.sortSelected = this.sortSelected;
					history.replaceState(state, document.title, window.location.href);
				}
			}
		},
		created: function () {
			if (!!(cafe.util.canUseHistory() && history.state)) {
				var state = history.state || {};
				this.categorySelected = state.categorySelected || '';
				this.sortSelected = state.sortSelected || 'hourly';
				delete state.categorySelected;
				delete state.sortSelected;
			}

			this.getRankingList();
		},
		watch: {
			rankingList: function (toBe) {
				var grpcode = this.landingGrpcode;

				if (!grpcode) {
					return;
				}

				var indexOfCafeByGrpcode;
				for (indexOfCafeByGrpcode = 0; indexOfCafeByGrpcode < toBe.length; indexOfCafeByGrpcode++) {
					if (toBe[indexOfCafeByGrpcode].grpcode === grpcode) {
						break;
					}
				}

				if (indexOfCafeByGrpcode >= toBe.length) {
					return;
				}

				this.currentPage = Math.floor(indexOfCafeByGrpcode / this.pagingCount) + 1;
				this.needLanding = true;
			},
			currentPage: function (toBe) {
				if (cafe.util.canUseHistory()) {
					var state = history.state || {};
					state.currentPage = toBe;
					history.replaceState(state, document.title, window.location.href);
				}
			},
			saveCurrentState: function () {
				if (!!(cafe.util.canUseHistory() && history.state)) {
					var state = history.state || {};
					state.scrollTop = window.scrollY;
					state.sortSelected = this.sortSelected;
					history.replaceState(state, document.title, window.location.href);
				}
			}
		},
		mounted: function () {
			this.$root.$on('link-clicked', this.saveCurrentState);
		},
		updated: function () {
			if (this.needLanding) {
				var grpcode = this.landingGrpcode.replace(/\./g, '\\.');
				var landingElement = this.$el.querySelector('#' + grpcode);
				landingElement.classList.add('rank_list--landing');
				cafe.util.scrollToCenter(landingElement);
				this.clearLanding();
			}

			if (!!(cafe.util.canUseHistory() && history.state && history.state.scrollTop)) {
				var state = history.state || {};
				window.scroll(0, state.scrollTop);
				delete state.scrollTop;
				history.replaceState(state, document.title, window.location.href);
			}
		}
	}),
	cafeRankingSection: Vue.component('cafe-ranking-section', {
		props: ['currentPage', 'isInCafeApp'],
		template: '' +
			'<section class="rank_wrap" id="cafe">' +
			'	<h1 class="sr_only">카페랭킹</h1>' +
			'	<div class="sort_wrap">' +
			'		<sort-time-select :options="sort" :selected="sortSelected" :ranking-time="rankingTime" :section-name="sectionName" v-on:sort-time-selected="onSortTimeSelected"></sort-time-select>' +
			'	</div>' +
			'	<div class="rank_list_wrap">' +
			'		<ranking-list :ranking-list="rankingList.slice(0, 10)" key-name="grpid" :section-name="sectionName" :is-top-ranking="true" :is-in-cafe-app="isInCafeApp"></ranking-list>' +
			'		<ranking-list v-if="rankingList.length > 10" :ranking-list="rankingList.slice(10, visibleItemCount)" key-name="grpid" :section-name="sectionName" :is-top-ranking="false" :is-in-cafe-app="isInCafeApp"></ranking-list>' +
			'	</div>' +
			'	<ranking-more v-if="hasNext" v-on:more="getNext"></ranking-more>' +
			'</section>',
		data: function () {
			return {
				sectionName: 'cafe',
				pagingCount: 30,
				sort: [
					{value: 'hourly', name: '실시간', format: 'HH:mm'},
					{value: 'daily', name: '일간', format: 'M월 D일'},
					{value: 'annually', name: '연간', format: 'YYYY년'}
				],
				sortSelected: 'hourly',
				rankingList: [{},{},{},{},{}]
			};
		},
		computed: {
			hasNext: function () {
				return this.visibleItemCount < this.rankingList.length;
			},
			visibleItemCount: function () {
				return this.pagingCount * this.currentPage;
			},
			rankingTime: function () {
				switch (this.sortSelected) {
				case 'hourly':
					return moment().startOf('hour').valueOf();
				case 'daily':
					return moment().startOf('day').subtract(1, 'days').valueOf();
				case 'annually':
					return moment().startOf('year').valueOf();
				default:
					return moment();
				}
			}
		},
		provide: function () {
			return {
				getNext: this.getNext
			};
		},
		methods: {
			resetPaging: function () {
				this.currentPage = 1;
			},
			onSortTimeSelected: function (sortSelected) {
				if (this.sortSelected === sortSelected) {
					return;
				}

				this.sortSelected = sortSelected;
				this.resetPaging();
				this.getRankingList();
			},
			getRankingList: function () {
				var vueObject = this;
				switch (this.sortSelected) {
				case 'hourly':
					cafe.fancafe.ranking.apiCaller.getCafeRankingByHourly(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cafeRankViewList;
					});
					break;
				case 'daily':
					cafe.fancafe.ranking.apiCaller.getCafeRankingByDaily(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cafeRankViewList;
					});
					break;
				case 'annually':
					cafe.fancafe.ranking.apiCaller.getCafeRankingByAnnually(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cafeRankViewList;
					});
					break;
				}
			},
			getNext: function () {
				this.currentPage++;
			},
			saveCurrentState: function () {
				if (!!(cafe.util.canUseHistory() && history.state)) {
					var state = history.state || {};
					state.scrollTop = window.scrollY;
					state.sortSelected = this.sortSelected;
					history.replaceState(state, document.title, window.location.href);
				}
			}
		},
		watch: {
			currentPage: function (toBe) {
				if (cafe.util.canUseHistory()) {
					var state = history.state || {};
					state.currentPage = toBe;
					history.replaceState(state, document.title, window.location.href);
				}
			}
		},
		created: function () {
			if (!!(cafe.util.canUseHistory() && history.state)) {
				var state = history.state || {};
				this.sortSelected = state.sortSelected || 'hourly';
				delete state.sortSelected;
			}

			this.getRankingList();
		},
		mounted: function () {
			this.$root.$on('link-clicked', this.saveCurrentState);
		},
		updated: function () {
			if (!!(cafe.util.canUseHistory() && history.state && history.state.scrollTop)) {
				var state = history.state || {};
				window.scroll(0, state.scrollTop);
				delete state.scrollTop;
				history.replaceState(state, document.title, window.location.href);
			}
		}
	}),
	cheerRankingSection: Vue.component('cheer-ranking-section', {
		props: ['currentPage', 'isInCafeApp'],
		template: '' +
			'<section class="rank_wrap" id="cheer">' +
			'	<h1 class="sr_only">응원랭킹</h1>' +
			'	<div class="sort_wrap">' +
			'		<sort-time-select :options="sort" :selected="sortSelected" :ranking-time="rankingTime" :section-name="sectionName" v-on:sort-time-selected="onSortTimeSelected"></sort-time-select>' +
			'	</div>' +
			'	<div class="rank_list_wrap">' +
			'		<ranking-list :ranking-list="rankingList.slice(0, 10)" key-name="grpid" :section-name="sectionName" :is-top-ranking="true" :is-in-cafe-app="isInCafeApp"></ranking-list>' +
			'		<ranking-list v-if="rankingList.length > 10" :ranking-list="rankingList.slice(10, visibleItemCount)" key-name="grpid" :section-name="sectionName" :is-top-ranking="false" :is-in-cafe-app="isInCafeApp"></ranking-list>' +
			'	</div>' +
			'	<ranking-more v-if="hasNext" v-on:more="getNext"></ranking-more>' +
			'</section>',
		data: function () {
			return {
				sectionName: 'cheer',
				pagingCount: 30,
				sort: [
					{value: 'hourly', name: '실시간', format: 'HH:mm'},
					{value: 'daily', name: '일간', format: 'M월 D일'},
					{value: 'weekly', name: '주간', format: '' },
					{value: 'annually', name: '연간', format: 'YYYY년'}
				],
				sortSelected: 'hourly',
				rankingList: [{},{},{},{},{}]
			};
		},
		computed: {
			hasNext: function () {
				return this.visibleItemCount < this.rankingList.length;
			},
			visibleItemCount: function () {
				return this.pagingCount * this.currentPage;
			},
			getWeeklyOption: function () {
				var thisThursDay = moment().subtract(7, 'days').day('Thursday');
				var firstThursDayOfMonth = thisThursDay.clone().startOf('month').day('Thursday');
				return thisThursDay.format('M') + '월 ' + (thisThursDay.format('W') - firstThursDayOfMonth.format('W') + 1 + '') + '주';
			},
			rankingTime: function () {
				switch (this.sortSelected) {
				case 'hourly':
					return moment().startOf('hour').valueOf();
				case 'daily':
					return moment().startOf('day').subtract(1, 'days').valueOf();
				case 'weekly':
					return this.getWeeklyOption;
				case 'annually':
					return moment().startOf('year').valueOf();
				default:
					return moment();
				}
			}
		},
		methods: {
			resetPaging: function () {
				this.currentPage = 1;
			},
			onSortTimeSelected: function (sortSelected) {
				if (this.sortSelected === sortSelected) {
					return;
				}

				this.sortSelected = sortSelected;
				this.resetPaging();
				this.getRankingList();
			},
			getRankingList: function () {
				var vueObject = this;
				switch (this.sortSelected) {
				case 'hourly':
					cafe.fancafe.ranking.apiCaller.getCheerRankingByHourly(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cheerRankViewList;
					});
					break;
				case 'daily':
					cafe.fancafe.ranking.apiCaller.getCheerRankingByDaily(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cheerRankViewList;
					});
					break;
				case 'weekly':
					cafe.fancafe.ranking.apiCaller.getCheerRankingByWeekly(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cheerRankViewList;
					});
					break;
				case 'annually':
					cafe.fancafe.ranking.apiCaller.getCheerRankingByAnnually(this.categorySelected).done(function (res) {
						vueObject.rankingList = res.cheerRankViewList;
					});
					break;
				}
			},
			getNext: function () {
				this.currentPage++;
			},
			saveCurrentState: function () {
				if (!!(cafe.util.canUseHistory() && history.state)) {
					var state = history.state || {};
					state.scrollTop = window.scrollY;
					state.sortSelected = this.sortSelected;
					history.replaceState(state, document.title, window.location.href);
				}
			}
		},
		watch: {
			currentPage: function (toBe) {
				if (cafe.util.canUseHistory()) {
					var state = history.state || {};
					state.currentPage = toBe;
					history.replaceState(state, document.title, window.location.href);
				}
			}
		},
		created: function () {
			if (!!(cafe.util.canUseHistory() && history.state && history.state.sortSelected)) {
				var state = history.state || {};
				this.sortSelected = state.sortSelected || 'hourly';
				delete state.sortSelected;
			}

			this.getRankingList();
		},
		mounted: function () {
			this.$root.$on('link-clicked', this.saveCurrentState);
		},
		updated: function () {
			if (!!(cafe.util.canUseHistory() && history.state && history.state.scrollTop)) {
				var state = history.state || {};
				window.scroll(0, state.scrollTop);
				delete state.scrollTop;
				history.replaceState(state, document.title, window.location.href);
			}
		}
	}),
	simpleOption: Vue.component('simple-option', {
		props: ['value', 'name'],
		template: '<option :value="value">{{name}}</option>'
	}),
	sortCategorySelect: Vue.component('sort-category-select', {
		props: ['categories', 'sectionName', 'selected'],
		template: '' +
			'<div class="sort_category_wrap">' +
			'	<span class="sort_selected_name" aria-hidden="true">{{optionNameByValue(selected)}}</span>' +
			'	<select title="전체분야" :id="sectionName + \'_sort_category\'" :value="selected" class="sort_select" @change="onChange">' +
			'		<simple-option v-for="option in categories" :value="option.value" :name="option.name"></simple-option>' +
			'	</select>' +
			'</div>',
		methods: {
			optionNameByValue: function (value) {
				return this.categories.find(function(category) {
					return category.value === value;
				}).name;
			},
			onChange: function (e) {
				this.$emit('sort-category-selected', e.target.value);
			}
		}
	}),
	sortTimeSelect: Vue.component('sort-time-select', {
		props: ['options', 'selected', 'rankingTime', 'sectionName'],
		template: '' +
			'<div class="sort_time_wrap">' +
			'	<label v-if="isWeeklyRanking" :for="sectionName + \'_sort_time\'" class="time_label">{{rankingTime}}</label>' +
			'	<label v-else-if="ableDisplayTime" :for="sectionName + \'_sort_time\'" class="time_label"><time :datetime="momentDatetime.format()">{{momentDatetime.format(selectedOption.format)}}</time></label>' +
			'	<span class="sort_selected_name" aria-hidden="true">{{selectedOption.name}}</span>' +
			'	<select title="정렬" :id="sectionName + \'_sort_time\'" class="sort_select" :value="selected" @change="onChange">' +
			'		<simple-option v-for="option in options" :value="option.value" :name="option.name"></simple-option>' +
			'	</select>' +
			'</div>',
		computed: {
			momentDatetime: function () {
				return moment(this.rankingTime);
			},
			selectedOption: function () {
				var value = this.selected;
				var selectedOptionValue = this.options.find(function (option) {
					return option.value === value;
				});
				return selectedOptionValue || {value: '', name: '', format: ''};
			},
			ableDisplayTime: function () {
				return this.rankingTime && this.selectedOption && this.selectedOption.format;
			},
			isWeeklyRanking: function () {
				return this.selectedOption && this.selectedOption.value === 'weekly';
			}
		},
		methods: {
			onChange: function (e) {
				this.$emit('sort-time-selected', e.target.value);
			}
		}
	}),
	rankingMore: Vue.component('ranking-more', {
		template: '' +
			'<div class="more">' +
			'	<button class="more_button" @click="onClick">더보기</button>' +
			'</div>',
		methods: {
			onClick: function () {
				this.$emit('more');
			}
		}
	}),
	rankingDiff: Vue.component('ranking-diff', {
		props: ['currRank', 'prevRank', 'isFirst'],
		template: '' +
			'<span v-if="isFirst" class="rank_list-stand-diff rank_list-stand-diff--first">' +
			'	<span v-if="currRank < prevRank" class="rank_list-stand-diff-up rank_list-stand-diff-up--first">{{diffRank}}<span class="sr_only">상승</span></span>' +
			'	<span v-else-if="currRank > prevRank" class="rank_list-stand-diff-down rank_list-stand-diff-down--first">{{diffRank}}<span class="sr_only">하강</span></span>' +
			'	<span v-else class="rank_list-stand-diff-same rank_list-stand-diff-same--first"><span class="sr_only">변동 없음</span></span>' +
			'</span>' +
			'<span v-else class="rank_list-stand-diff">' +
			'	<span v-if="currRank < prevRank" class="rank_list-stand-diff-up">{{diffRank}}<span class="sr_only">상승</span></span>' +
			'	<span v-else-if="currRank > prevRank" class="rank_list-stand-diff-down">{{diffRank}}<span class="sr_only">하강</span></span>' +
			'	<span v-else class="rank_list-stand-diff-same"><span class="sr_only">변동 없음</span></span>' +
			'</span>',
		computed: {
			diffRank: function () {
				return Math.abs(this.prevRank - this.currRank);
			}
		}
	}),
	rankingList: Vue.component('ranking-list', {
		props: ['rankingList', 'keyName', 'options', 'sectionName', 'isTopRanking', 'isInCafeApp'],
		template: '' +
			'<ul>' +
			'	<component :is="getComponentNameBy(sectionName)" v-for="(item, index) in rankingList" :key="item[keyName]" :item="item" :options="options" :is-first="isTopRanking && index === 0" :is-in-cafe-app="isInCafeApp"></component>' +
			'</ul>',
		methods: {
			getComponentNameBy: function (sectionName) {
				return sectionName + '-ranking-item';
			}
		}
	}),
	fandomRankingItem: Vue.component('fandom-ranking-item', {
		props: ['item', 'isFirst', 'options', 'isInCafeApp'],
		template: '' +
			'<li v-if="isFirst" :id="item.grpcode" class="rank_list rank_list--first">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail rank_list-thumbnail--first">' +
			'			<img v-if="item.topRankImageUrl" width="375" height="280" :src="imgToThumbnail(item.topRankImageUrl, 750, 560, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content rank_list-content--first">' +
			'			<div class="rank_list-stand rank_list-stand--first">' +
			'				<span class="sr_only">종합 순위</span>' +
			'				<em v-if="item.fandomCurrRank" class="rank_list-stand-number rank_list-stand-number--first">{{toLocaleString(getCurrRankByCategorySelected(item))}}</em>' +
			'				<em v-else class="rank_list-stand-number rank_list-stand-number--first rank_list-stand-number--skeleton"></em>' +
			'				<span class="sr_only">등</span>' +
			'				<ranking-diff :curr-rank="getCurrRankByCategorySelected(item)" :prevRank="getPrevRankByCategorySelected(item)" :is-first="true"></ranking-diff>' +
			'			</div>' +
			'			<div class="rank_list-source rank_list-source--first">' +
			'				<div class="rank_list-source-header rank_list-source-header--first">' +
			'					<strong v-if="true" class="rank_list-source-header-title rank_list-source-header-title--first">{{item.starName}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--first rank_list-source-header-title--skeleton"></strong>' +
			'				</div>' +
			'				<div class="rank_list-source-part">' +
			'					<span v-if="item.cafeCurrRank || item.cafeCurrRank === 0" class="rank_list-source-part-cafe"></span>' +
			'					<span v-if="item.cafeCurrRank || item.cafeCurrRank === 0" class="rank_list-source-part-category rank_list-source-part-category--first">카페 <em class="rank_list-source-part-category-score">{{toLocaleString(item.cafeCurrRank)}}등</em></span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--skeleton"></span>' +
			'				</div>' +
			'				<div v-if="item.cheerCurrRank || item.cheerCurrRank === 0" class="rank_list-source-part">' +
			'					<span class="rank_list-source-part-cheer"></span>' +
			'					<span class="rank_list-source-part-category rank_list-source-part-category--first">응원 <em class="rank_list-source-part-category-score">{{toLocaleString(item.cheerCurrRank)}}등</em></span>' +
			'				</div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>' +
			'<li v-else :id="item.grpcode" class="rank_list">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail">' +
			'			<img v-if="item.profileImageUrl" width="52" height="52" :src="imgToThumbnail(item.profileImageUrl, 104, 104, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content">' +
			'			<div class="rank_list-stand">' +
			'				<span class="sr_only">종합 순위</span>' +
			'				<em v-if="item.fandomCurrRank" class="rank_list-stand-number">{{toLocaleString(getCurrRankByCategorySelected(item))}}</em>' +
			'				<em v-else class="rank_list-stand-number rank_list-stand-number--skeleton"></em>' +
			'				<span class="sr_only">등</span>' +
			'				<ranking-diff :curr-rank="getCurrRankByCategorySelected(item)" :prevRank="getPrevRankByCategorySelected(item)" :is-first="false"></ranking-diff>' +
			'			</div>' +
			'			<div class="rank_list-source">' +
			'				<div class="rank_list-source-header">' +
			'					<strong v-if="true" class="rank_list-source-header-title">{{item.starName}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--skeleton"></strong>' +
			'				</div>' +
			'				<div class="rank_list-source-part">' +
			'					<span v-if="item.cafeCurrRank || item.cafeCurrRank === 0" class="rank_list-source-part-cafe"></span>' +
			'					<span v-if="item.cafeCurrRank || item.cafeCurrRank === 0" class="rank_list-source-part-category">카페 <em class="rank_list-source-part-category-score">{{toLocaleString(item.cafeCurrRank)}}등</em></span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--skeleton"></span>' +
			'				</div>' +
			'				<div v-if="item.cheerCurrRank || item.cheerCurrRank === 0" class="rank_list-source-part">' +
			'					<span class="rank_list-source-part-cheer"></span>' +
			'					<span class="rank_list-source-part-category">응원 <em class="rank_list-source-part-category-score">{{toLocaleString(item.cheerCurrRank)}}등</em></span>' +
			'				</div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>',
		methods: {
			getLink: function (item) {
				if (this.isInCafeApp) {
					return 'daumcafe://cafehome?grpcode=' + item.grpcode;
				}
				return '/' + item.grpcode;
			},
			getCurrRankByCategorySelected: function (item) {
				if (!this.options) {
					return item.fandomCurrRank;
				}

				return item.categoryCurrRank;
			},
			getPrevRankByCategorySelected: function (item) {
				if (!this.options) {
					return item.fandomPrevRank;
				}

				return item.categoryPrevRank;
			},
			imgToThumbnail: Utils.getThumbnail,
			toLocaleString: cafe.util.toLocaleString,
			onClick: function (e) {
				this.$root.$emit('link-clicked');
			}
		}
	}),
	cafeRankingItem: Vue.component('cafe-ranking-item', {
		props: ['item', 'isFirst', 'isInCafeApp'],
		template: '' +
			'<li v-if="isFirst" :id="item.grpcode" class="rank_list rank_list--first">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail rank_list-thumbnail--first">' +
			'			<img v-if="item.topRankImageUrl" width="375" height="280" :src="imgToThumbnail(item.topRankImageUrl, 750, 560, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content rank_list-content--first">' +
			'			<div class="rank_list-stand rank_list-stand--first rank_list-stand--cafe">' +
			'				<span class="sr_only">카페 순위</span>' +
			'				<em v-if="item.cafeCurrRank" class="rank_list-stand-number rank_list-stand-number--first">{{toLocaleString(item.cafeCurrRank)}}</em>' +
			'				<em v-else class="rank_list-stand-number rank_list-stand-number--first rank_list-stand-number--skeleton"></em>' +
			'				<span class="sr_only">등</span>' +
			'				<ranking-diff :curr-rank="item.cafeCurrRank" :prevRank="item.cafePrevRank" :is-first="true"></ranking-diff>' +
			'			</div>' +
			'			<div class="rank_list-source rank_list-source--first">' +
			'				<div class="rank_list-source-header rank_list-source-header--first">' +
			'					<strong v-if="true" class="rank_list-source-header-title rank_list-source-header-title--first">{{item.starName}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--first rank_list-source-header-title--skeleton"></strong>' +
			'					<span v-if="item.starJoin" class="rank_list-source-header-tag rank_list-source-header-tag--first">스타가입</span><span v-if="item.manage" class="rank_list-source-header-tag rank_list-source-header-tag--first">소속사</span>' +
			'				</div>' +
			'				<div class="rank_list-source-part">' +
			'					<span v-if="item.visitScore || item.visitScore === 0" class="rank_list-source-part-category rank_list-source-part-category--first">방문 <em class="rank_list-source-part-category-score">{{toLocaleString(item.visitScore)}}</em></span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--skeleton"></span>' +
			'				</div>' +
			'				<div v-if="item.newMemberScore || item.newMemberScore === 0" class="rank_list-source-part">' +
			'					<span class="rank_list-source-part-category rank_list-source-part-category--first">가입 <em class="rank_list-source-part-category-score">{{toLocaleString(item.newMemberScore)}}</em></span>' +
			'				</div>' +
			'				<div v-if="item.newArticleScore || item.newArticleScore === 0" class="rank_list-source-part">' +
			'					<span class="rank_list-source-part-category rank_list-source-part-category--first">새글 <em class="rank_list-source-part-category-score">{{toLocaleString(item.newArticleScore)}}</em></span>' +
			'				</div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>' +
			'<li v-else :id="item.grpcode" class="rank_list">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail">' +
			'			<img v-if="item.profileImageUrl" width="52" height="52" :src="imgToThumbnail(item.profileImageUrl, 104, 104, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content">' +
			'			<div class="rank_list-stand">' +
			'				<span class="sr_only">카페 순위</span>' +
			'				<em v-if="item.cafeCurrRank" class="rank_list-stand-number">{{toLocaleString(item.cafeCurrRank)}}</em>' +
			'				<em v-else class="rank_list-stand-number rank_list-stand-number--skeleton"></em>' +
			'				<span class="sr_only">등</span>' +
			'				<ranking-diff :curr-rank="item.cafeCurrRank" :prevRank="item.cafePrevRank" :is-first="false"></ranking-diff>' +
			'			</div>' +
			'			<div class="rank_list-source">' +
			'				<div class="rank_list-source-header">' +
			'					<strong v-if="true" class="rank_list-source-header-title">{{item.starName}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--skeleton"></strong>' +
			'					<span v-if="item.starJoin" class="rank_list-source-header-tag">스타가입</span><span v-if="item.manage" class="rank_list-source-header-tag">소속사</span>' +
			'				</div>' +
			'				<div class="rank_list-source-part">' +
			'					<span v-if="item.visitScore || item.visitScore === 0" class="rank_list-source-part-category">방문 <em class="rank_list-source-part-category-score">{{toLocaleString(item.visitScore)}}</em></span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--skeleton"></span>' +
			'				</div>' +
			'				<div v-if="item.newMemberScore || item.newMemberScore === 0" class="rank_list-source-part">' +
			'					<span class="rank_list-source-part-category">가입 <em class="rank_list-source-part-category-score">{{toLocaleString(item.newMemberScore)}}</em></span>' +
			'				</div>' +
			'				<div v-if="item.newArticleScore || item.newArticleScore === 0" class="rank_list-source-part">' +
			'					<span class="rank_list-source-part-category">새글 <em class="rank_list-source-part-category-score">{{toLocaleString(item.newArticleScore)}}</em></span>' +
			'				</div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>',
		methods: {
			getLink: function (item) {
				if (this.isInCafeApp) {
					return 'daumcafe://cafehome?grpcode=' + item.grpcode;
				}
				return '/' + item.grpcode;
			},
			imgToThumbnail: Utils.getThumbnail,
			toLocaleString: cafe.util.toLocaleString,
			onClick: function () {
				this.$root.$emit('link-clicked');
			}
		}
	}),
	cheerRankingItem: Vue.component('cheer-ranking-item', {
		props: ['item', 'isFirst', 'isInCafeApp'],
		template: '' +
			'<li v-if="isFirst" :id="item.grpcode" class="rank_list rank_list--first">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail rank_list-thumbnail--first">' +
			'			<img v-if="item.topRankImageUrl" width="375" height="280" :src="imgToThumbnail(item.topRankImageUrl, 750, 560, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content rank_list-content--first">' +
			'			<div class="rank_list-stand rank_list-stand--first rank_list-stand--cheer">' +
			'				<span class="sr_only">응원 순위</span>' +
			'				<em v-if="item.cheerCurrRank" class="rank_list-stand-number rank_list-stand-number--first">{{toLocaleString(item.cheerCurrRank)}}</em>' +
			'				<em v-else class="rank_list-stand-number rank_list-stand-number--first rank_list-stand-number--skeleton"></em>' +
			'				<span class="sr_only">등</span>' +
			'				<ranking-diff :curr-rank="item.cheerCurrRank" :prevRank="item.cheerPrevRank" :is-first="true"></ranking-diff>' +
			'			</div>' +
			'			<div class="rank_list-source rank_list-source--first">' +
			'				<div class="rank_list-source-header rank_list-source-header--first">' +
			'					<strong v-if="true" class="rank_list-source-header-title rank_list-source-header-title--first">{{item.starName}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--first rank_list-source-header-title--skeleton"></strong>' +
			'				</div>' +
			'				<div class="rank_list-source-part">' +
			'					<span v-if="item.cheerScore || item.cheerScore === 0" class="rank_list-source-part-category rank_list-source-part-category--first">응원 <em class="rank_list-source-part-category-score">{{toLocaleString(item.cheerScore)}}</em></span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--skeleton"></span>' +
			'				</div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>' +
			'<li v-else :id="item.grpcode" class="rank_list">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail">' +
			'			<img v-if="item.profileImageUrl" width="52" height="52" :src="imgToThumbnail(item.profileImageUrl, 104, 104, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content">' +
			'			<div class="rank_list-stand">' +
			'				<span class="sr_only">응원 순위</span>' +
			'				<em v-if="item.cheerCurrRank" class="rank_list-stand-number">{{toLocaleString(item.cheerCurrRank)}}</em>' +
			'				<em v-else class="rank_list-stand-number rank_list-stand-number--skeleton"></em>' +
			'				<span class="sr_only">등</span>' +
			'				<ranking-diff :curr-rank="item.cheerCurrRank" :prevRank="item.cheerPrevRank" :is-first="false"></ranking-diff>' +
			'			</div>' +
			'			<div class="rank_list-source">' +
			'				<div class="rank_list-source-header">' +
			'					<strong v-if="true" class="rank_list-source-header-title">{{item.starName}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--skeleton"></strong>' +
			'				</div>' +
			'				<div class="rank_list-source-part">' +
			'					<span v-if="item.cheerScore || item.cheerScore === 0" class="rank_list-source-part-category">응원 <em class="rank_list-source-part-category-score">{{toLocaleString(item.cheerScore)}}</em></span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--skeleton"></span>' +
			'				</div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>',
		methods: {
			getLink: function (item) {
				if (this.isInCafeApp) {
					return 'daumcafe://cafehome?grpcode=' + item.grpcode;
				}
				return '/' + item.grpcode;
			},
			imgToThumbnail: Utils.getThumbnail,
			toLocaleString: cafe.util.toLocaleString,
			onClick: function () {
				this.$root.$emit('link-clicked');
			}
		}
	}),
	magazineRankingItem: Vue.component('magazine-ranking-item', {
		props: ['item', 'isFirst', 'isInCafeApp'],
		template: '' +
			'<li v-if="isFirst" :id="item.grpcode" class="rank_list rank_list--first">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail rank_list-thumbnail--first">' +
			'			<img v-if="item.imgurl" width="375" height="280" :src="imgToThumbnail(item.imgurl, 750, 560, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content rank_list-content--first">' +
			'			<div v-if="item.currRank > 0" class="rank_list-stand rank_list-stand--first rank_list-stand--magazine">' +
			'				<span class="sr_only">팬매거진 순위</span>' +
			'				<em class="rank_list-stand-number rank_list-stand-number--first">{{toLocaleString(item.currRank)}}</em>' +
			'				<span class="sr_only">등</span>' +
			'			</div>' +
			'			<div class="rank_list-source rank_list-source--magazine rank_list-source--first">' +
			'				<div class="rank_list-source-header rank_list-source-header--magazine_first">' +
			'					<strong v-if="item.title" class="rank_list-source-header-title rank_list-source-header-title--first">{{htmlDecode(item.title)}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--first rank_list-source-header-title--skeleton_magazine"></strong>' +
			'				</div>' +
			'				<div class="rank_list-source-part rank_list-source-part--magazine rank_list-source-part--register_info">' +
			'					<span v-if="item.nickname" class="rank_list-source-part-category rank_list-source-part-category--author rank_list-source-part-category--first">{{item.nickname}}</span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--author rank_list-source-part-category--first rank_list-source-part-category--skeleton"></span>' +
			'					<time v-if="item.regdttm" class="rank_list-source-part-time" datetime="regdttmToDatetimeFormat(item.regdttm)">{{regdttmToShortFormat(item.regdttm)}}</time>' +
			'				</div>' +
			'				<div v-if="item.actionCount || item.actionCount === 0" class="rank_list-source-part rank_list-source-part--magazine">좋아요 <em>{{toLocaleString(item.actionCount)}}</em></div>' +
			'				<div v-else class="rank_list-source-part rank_list-source-part--magazine rank_list-source-part--skeleton"></div>' +
			'				<div v-if="item.commentCount || item.commentCount === 0" class="rank_list-source-part rank_list-source-part--magazine">댓글 <em>{{toLocaleString(item.commentCount)}}</em></div>' +
			'				<div v-if="item.starName" class="rank_list-source-part rank_list-source-part--magazine"><span class="rank_list-source-part-starname">{{item.starName}}</span></div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>' +
			'<li v-else :id="item.grpcode" class="rank_list">' +
			'	<a :href="getLink(item)" class="rank_list-link" @click="onClick">' +
			'		<div class="rank_list-thumbnail rank_list-thumbnail--magazine">' +
			'			<img v-if="item.imgurl" width="70" height="70" :src="imgToThumbnail(item.imgurl, 104, 104, \'S\')" alt="썸네일" class="rank_list-thumbnail-image">' +
			'			<span v-else class="rank_list-thumbnail-image rank_list-thumbnail-image--skeleton"></span>' +
			'		</div>' +
			'		<div class="rank_list-content">' +
			'			<div v-if="item.currRank > 0" class="rank_list-stand rank_list-stand--magazine_list">' +
			'				<span class="sr_only">팬매거진 순위</span>' +
			'				<em class="rank_list-stand-number">{{toLocaleString(item.currRank)}}</em>' +
			'				<span class="sr_only">등</span>' +
			'			</div>' +
			'			<div class="rank_list-source rank_list-source--magazine">' +
			'				<div class="rank_list-source-header rank_list-source-header--magazine">' +
			'					<strong v-if="item.title" class="rank_list-source-header-title rank_list-source-header-title--magazine">{{htmlDecode(item.title)}}</strong>' +
			'					<strong v-else class="rank_list-source-header-title rank_list-source-header-title--magazine rank_list-source-header-title--skeleton"></strong>' +
			'				</div>' +
			'				<div class="rank_list-source-part rank_list-source-part--magazine rank_list-source-part--register_info">' +
			'					<span v-if="item.nickname" class="rank_list-source-part-category rank_list-source-part-category--author">{{item.nickname}}</span>' +
			'					<span v-else class="rank_list-source-part-category rank_list-source-part-category--author rank_list-source-part-category--skeleton"></span>' +
			'					<time v-if="item.regdttm" class="rank_list-source-part-time" :datetime="regdttmToDatetimeFormat(item.regdttm)">{{regdttmToShortFormat(item.regdttm)}}</time>' +
			'				</div>' +
			'				<div v-if="item.actionCount || item.actionCount === 0" class="rank_list-source-part rank_list-source-part--magazine">좋아요 <em>{{toLocaleString(item.actionCount)}}</em></div>' +
			'				<div v-else class="rank_list-source-part rank_list-source-part--magazine rank_list-source-part--skeleton"></div>' +
			'				<div v-if="item.commentCount || item.commentCount === 0" class="rank_list-source-part rank_list-source-part--magazine">댓글 <em>{{toLocaleString(item.commentCount)}}</em></div>' +
			'				<div v-if="item.starName" class="rank_list-source-part rank_list-source-part--magazine"><span class="rank_list-source-part-starname">{{item.starName}}</span></div>' +
			'			</div>' +
			'		</div>' +
			'	</a>' +
			'</li>',
		methods: {
			htmlDecode: function (encodedHtml) {
				return encodedHtml.replace(/&amp;/g, '&')
								  .replace(/&quot;/g, '"')
								  .replace(/&lt;/g, '<')
								  .replace(/&gt;/g, '>');
			},
			getLink: function (item) {
				if (this.isInCafeApp) {
					return 'daumcafe://article?grpcode=' + item.grpcode + '&fldid=' + item.fldid + '&dataid=' + item.dataid;
				}
				return '/' + item.grpcode + '/' + item.fldid + '/' + item.dataid;
			},
			regdttmToDatetimeFormat: function (regdttm) {
				return moment(regdttm).format();
			},
			regdttmToShortFormat: function (regdttm) {
				var today = moment();
				var momentRegdttm = moment(regdttm);

				if (momentRegdttm.isSame(today, 'day')) {
					return momentRegdttm.format('HH:mm');
				}

				return momentRegdttm.format('YY.MM.DD');
			},
			imgToThumbnail: Utils.getThumbnail,
			toLocaleString: cafe.util.toLocaleString,
			onClick: function () {
				this.$root.$emit('link-clicked');
			}
		}
	})
};
